import { BATTLE_LAYOUT, HONOR_TITLES, PALETTE, resolveLayout, type Rect } from "@gaoya/shared";
import type { UiState } from "../game/state.js";
import { drawHonorPlaque } from "./widgets/honor.js";

export function drawDebug(
  ctx: CanvasRenderingContext2D,
  ui: UiState,
  w: number,
  h: number,
  now: number,
): void {
  if (!ui.debug) return;
  ctx.save();
  if (ui.screen === "battle") {
    const layout = resolveLayout(w, h);
    const keys = Object.keys(BATTLE_LAYOUT) as (keyof typeof BATTLE_LAYOUT)[];
    for (const key of keys) {
      const r = layout[key];
      strokeRect(ctx, r, PALETTE.cinnabar, 1);
      ctx.fillStyle = "rgba(210,71,53,0.12)";
      ctx.fillRect(r.x, r.y, r.w, r.h);
      ctx.fillStyle = PALETTE.cinnabar;
      ctx.font = "11px sans-serif";
      ctx.textAlign = "left";
      ctx.textBaseline = "top";
      ctx.fillText(`${key} ${r.w}×${r.h}`, r.x + 4, r.y + 4);
    }
  }

  const boxW = Math.min(240, w - 16);
  const boxH = 168;
  const x = 8;
  const y = 36;
  ctx.fillStyle = "rgba(35,39,42,0.78)";
  roundFill(ctx, x, y, boxW, boxH, 6);
  ctx.fillStyle = PALETTE.moon;
  ctx.font = "11px monospace";
  ctx.textAlign = "left";
  ctx.textBaseline = "top";
  const lines = [
    `fsm ${ui.screen}${ui.showLeaderboard ? "/rank" : ""}`,
    `fps ${ui.fps.toFixed(0)}  dpr-clock ${ui.clockOffset.toFixed(0)}ms`,
    `auth ${ui.authed ? "yes" : "no"}  ws ${ui.connected ? "up" : "down"}`,
    `turn ${ui.currentTurnId === ui.userId ? "ME" : ui.currentTurnId ? "OPP" : "-"} r${ui.round}`,
    `hp ${ui.selfHp}/${ui.oppHp}  abbr ${ui.abbr || "-"}`,
  ];
  for (let i = 0; i < lines.length; i++) {
    ctx.fillText(lines[i] ?? "", x + 8, y + 8 + i * 14);
  }
  ctx.fillText("— proto —", x + 8, y + 8 + 5 * 14);
  const msgs = ui.lastMsgs.slice(-8);
  for (let i = 0; i < msgs.length; i++) {
    const m = msgs[i];
    if (!m) continue;
    const age = Math.max(0, now - m.ts);
    ctx.fillStyle = m.dir === "in" ? PALETTE.bamboo : PALETTE.gamboge;
    ctx.fillText(`${m.dir === "in" ? "↓" : "↑"} ${m.action} ${Math.round(age / 100)}`, x + 8, y + 8 + 6 * 14 + i * 12);
  }
  let py = 72;
  for (const title of HONOR_TITLES) {
    drawHonorPlaque(ctx, w - 62, py, title);
    py += 22;
  }
  ctx.restore();
}

function strokeRect(ctx: CanvasRenderingContext2D, r: Rect, color: string, width: number): void {
  ctx.strokeStyle = color;
  ctx.lineWidth = width;
  ctx.strokeRect(r.x + 0.5, r.y + 0.5, r.w - 1, r.h - 1);
}

function roundFill(ctx: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, r: number): void {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
  ctx.fill();
}
